import defaultLayout from '../../../layouts/default'
import edmLayout from '../../../layouts/edm'

export default {
  path: 'edm',
  component: defaultLayout,
  children: [
    {
      path: '',
      component: edmLayout,
      children: [
        {
          path: 'list',
          component: () => import('./list/list.vue'),
          meta: {
            activeMenu: 'edm',
            auth: true
          }
        },
        {
          path: 'draft',
          component: () => import('./draft/draft.vue'),
          meta: {
            activeMenu: 'edm',
            auth: true
          }
        },
        {
          path: 'tpl',
          component: () => import('./tpl/tpl.vue'),
          meta: {
            activeMenu: 'edm',
            auth: true
          }
        },
        {
          path: 'filter',
          component: () => import('./filter/filter.vue'),
          meta: {
            activeMenu: 'edm',
            auth: true
          }
        }
      ]
    },
    {
      path: 'edit',
      component: () => import('./edit/edit.vue'),
      meta: {
        activeMenu: 'edm',
        auth: true
      }
    },
    {
      path: 'confirm',
      component: () => import('./confirm/confirm.vue'),
      meta: {
        activeMenu: 'edm',
        auth: true
      }
    },
    {
      path: 'preview',
      component: () => import('./preview/preview.vue'),
      meta: {
        activeMenu: 'edm',
        auth: true
      }
    },
    {
      path: 'detail',
      component: () => import('./detail/detail.vue'),
      meta: {
        activeMenu: 'edm',
        auth: true
      }
    },
    {
      path: 'messagecontent',
      component: () => import('./messagecontent/messagecontent.vue'),
      meta: {
        activeMenu: 'edm',
        auth: true,
        noHeader: true
      }
    },
    {
      path: 'tpledit',
      component: () => import('./tpledit/tpledit.vue'),
      meta: {
        activeMenu: 'edm',
        auth: true
      }
    }
  ]
}
